'use strict';

/**
 * Collection for the exports
 *
 * @category   Collection
 * @module     Export
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCollection = require('base/Colido.Collection');
var ExportModel = require('../models/export');

var ExportsCollection = ColidoCollection.extend({
    api: '/export',

    sortDefault: 'id.desc',

    name: 'collection:exports',

    model: ExportModel,

    finishedStates: ['failed', 'complete'],

    unfinishedStates: ['queue', 'exporting', 'processing', 'waiting'],

    initialize: function() {
        //@todo update event in WS server. investigate if this is in fact needed at all. looks brainlessly copy and pasted from imports
        this.listenTo(App.radio('collection:export').vent, 'export:updated', function(data) {
            var importObject = this.get(data.id);
            if (importObject) {
                importObject.set(data);
            }
        }.bind(this));

        // To be discussed
        //this.listenTo(App.radio('collection').vent, 'object:destroy', this.removeObjectsFromImport.bind(this));
    },

    finished: function() {
        var finishedStates = this.finishedStates;

        return this.getFilteredCollection(function(model) {
            return _.contains(finishedStates, model.get('state'));
        });
    },

    unfinished: function() {
        var unfinishedStates = this.unfinishedStates;

        return this.getFilteredCollection(function(model) {
            return _.contains(unfinishedStates, model.get('state'));
        });
    },
});

module.exports = ExportsCollection;